"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const levels = {
    Debug: 'debug',
    Error: 'error',
    Info: 'info',
    Warn: 'warn',
};
